import {
  FpWebsocketMessage,
  useListenForFpWebsocketMessages
} from '@flicent/fieldpulse-react-component-library-frontend';

import { CustomFormWebsocketMessageAction, WEBSOCKET_ORIGIN, WEBSOCKET_TYPE_CUSTOM_FORM } from '@/constants';


export interface BaseCustomFormWebsocketMessage<A = CustomFormWebsocketMessageAction, D = any> extends FpWebsocketMessage<typeof WEBSOCKET_TYPE_CUSTOM_FORM, A, D> {

}

export interface CustomFormGenerateAndSaveFinishWebsocketMessage extends BaseCustomFormWebsocketMessage<CustomFormWebsocketMessageAction.PDF_GENERATE_AND_SAVE_FINISH, {
  form_id: number;
}> {
}

export interface CustomFormGenerateAndSaveErrorWebsocketMessage extends BaseCustomFormWebsocketMessage<CustomFormWebsocketMessageAction.PDF_GENERATE_AND_SAVE_ERROR, {
  error_detail: string;
  form_id: number;
}> {
}

export interface CustomFormReportSendFinishWebsocketMessage extends BaseCustomFormWebsocketMessage<CustomFormWebsocketMessageAction.REPORT_SEND_FINISH, {
  is_email_success: boolean;
  is_sms_success: boolean;
  form_id: number;
}> {
}

export interface CustomFormReportSendErrorWebsocketMessage extends BaseCustomFormWebsocketMessage<CustomFormWebsocketMessageAction.REPORT_SEND_ERROR, {
  error_detail: string;
  form_id: number;
}> {
}

type CustomFormWebsocketMessage =
  CustomFormGenerateAndSaveFinishWebsocketMessage
  | CustomFormGenerateAndSaveErrorWebsocketMessage
  | CustomFormReportSendFinishWebsocketMessage
  | CustomFormReportSendErrorWebsocketMessage;

interface UseCustomFormReportWebsocketMessagesArgument {
  token: string | null;
  onPdfGenerated: (formId: number) => void;
  onPdfGenerationError: (formId: number, errorDetail: string) => void;
  onReportSent: (formId: number, emailSuccess: boolean, smsSuccess: boolean) => void;
  onReportSendError: (formId: number, errorDetail: string) => void;
}

export const useCustomFormWebsocketMessages = ({
                                                 token,
                                                 onPdfGenerated,
                                                 onPdfGenerationError,
                                                 onReportSent,
                                                 onReportSendError,
                                               }: UseCustomFormReportWebsocketMessagesArgument) => {
  useListenForFpWebsocketMessages(token ? `${ WEBSOCKET_ORIGIN }/custom-form-report/socket?token=${ token }` : null, (message) => {
    if (message.type === WEBSOCKET_TYPE_CUSTOM_FORM) {
      const customFormMessage = message as CustomFormWebsocketMessage;
      switch (customFormMessage.action) {
        case CustomFormWebsocketMessageAction.PDF_GENERATE_AND_SAVE_FINISH: {
          onPdfGenerated(customFormMessage.data.form_id);
          break;
        }
        case CustomFormWebsocketMessageAction.PDF_GENERATE_AND_SAVE_ERROR: {
          onPdfGenerationError(customFormMessage.data.form_id, customFormMessage.data.error_detail);
          break;
        }
        case CustomFormWebsocketMessageAction.REPORT_SEND_FINISH: {
          onReportSent(customFormMessage.data.form_id, customFormMessage.data.is_email_success, customFormMessage.data.is_sms_success);
          break;
        }
        case CustomFormWebsocketMessageAction.REPORT_SEND_ERROR: {
          onReportSendError(customFormMessage.data.form_id, customFormMessage.data.error_detail);
          break;
        }
        default: {
          console.warn('Unknown custom form websocket message action:', customFormMessage);
        }
      }
    }
  });
};